"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireDefault(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _submitPql = require("ui-addon-upgrades/_core/pql/submitPql");

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITextArea = _interopRequireDefault(require("UIComponents/input/UITextArea"));

var _tracker = require("../common/eventTracking/tracker");

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Modal = (0, _styledComponents.default)(function (props) {
  // eslint-disable-next-line no-unused-vars
  var hideBackground = props.hideBackground,
      rest = (0, _objectWithoutProperties2.default)(props, ["hideBackground"]);
  return _react.default.createElement(_UIModal.default, rest);
}).withConfig({
  displayName: "EmailModal__Modal",
  componentId: "sc-9t2hyd-0"
})(["&&&{background-color:", ";}"], function (props) {
  return props.hideBackground ? 'transparent' : undefined;
});
var PQL_SUBMISSION_STATUSES = {
  INITIAL: 'initial',
  LOADING: 'loading',
  FAILED: 'failed',
  SUCCEEDED: 'succeeded'
};
var MODAL_CLOSE_DELAY_MILLIS = 800;

var EmailModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(EmailModal, _React$Component);

  function EmailModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmailModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EmailModal).call(this, props));
    _this._isMounted = true;
    _this.state = {
      subject: null,
      body: '',
      hasClickedSubmit: false,
      pqlSubmissionStatus: PQL_SUBMISSION_STATUSES.INITIAL
    };
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EmailModal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;

      var _this$state = this.state,
          subject = _this$state.subject,
          body = _this$state.body;
      var _this$props = this.props,
          upgradeData = _this$props.upgradeData,
          onReject = _this$props.onReject;
      this.setState({
        hasClickedSubmit: true
      });

      if (subject && body.length) {
        this.setState({
          pqlSubmissionStatus: PQL_SUBMISSION_STATUSES.LOADING
        });
        (0, _submitPql.submitPql)(upgradeData, {
          emailSubject: subject,
          emailBody: body
        }).then(function () {
          _this2.setState({
            pqlSubmissionStatus: PQL_SUBMISSION_STATUSES.SUCCEEDED
          });

          _tracker.tracker.track('communicationMethodsInteraction', Object.assign({
            action: 'submitted email message'
          }, upgradeData));

          setTimeout(function () {
            onReject();
          }, MODAL_CLOSE_DELAY_MILLIS);
        }).catch(function () {
          _this2.setState({
            pqlSubmissionStatus: PQL_SUBMISSION_STATUSES.FAILED
          });
        }).done();
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var onReject = this.props.onReject;
      onReject();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          onReject = _this$props2.onReject,
          hideBackground = _this$props2.hideBackground;
      var _this$state2 = this.state,
          subject = _this$state2.subject,
          body = _this$state2.body,
          hasClickedSubmit = _this$state2.hasClickedSubmit,
          pqlSubmissionStatus = _this$state2.pqlSubmissionStatus;
      return _react.default.createElement(Modal, {
        "data-test-id": "email-modal",
        width: 600,
        hideBackground: hideBackground
      }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.emailModal.header"
      })), _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: function onClick() {
          onReject();
        }
      })), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.emailModal.subject"
        }),
        error: hasClickedSubmit && !subject,
        validationMessage: hasClickedSubmit && !subject && _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.emailModal.errorMessages.subject"
        })
      }, _react.default.createElement(_UISelect.default, {
        value: subject,
        searchable: false,
        onChange: function onChange(event) {
          _this3.setState({
            subject: event.target.value
          });
        } //The message subjects are submitted to 53 in English
        ,
        options: [{
          text: _I18n.default.text("upgrades.emailModal.subjectDropdown.options.purchase"),
          value: 'I’m interested in purchasing a product'
        }, {
          text: _I18n.default.text("upgrades.emailModal.subjectDropdown.options.learnMore"),
          value: 'I want to learn more about a product or feature'
        }, {
          text: _I18n.default.text("upgrades.emailModal.subjectDropdown.options.help"),
          value: 'I need setup help or have a technical question'
        }, {
          text: _I18n.default.text("upgrades.emailModal.subjectDropdown.options.other"),
          value: 'Other'
        }],
        placeholder: _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.emailModal.subjectDropdown.placeholder"
        })
      })), _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.emailModal.body"
        }),
        error: hasClickedSubmit && body === '',
        validationMessage: hasClickedSubmit && body === '' && _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.emailModal.errorMessages.body"
        })
      }, _react.default.createElement(_UITextArea.default, {
        placeholder: _I18n.default.text('upgrades.emailModal.bodyPlaceholder'),
        rows: 10,
        resize: false,
        value: body,
        onChange: function onChange(event) {
          _this3.setState({
            body: event.target.value
          });
        }
      })), pqlSubmissionStatus === PQL_SUBMISSION_STATUSES.FAILED && _react.default.createElement(_UIAlert.default, {
        className: "m-top-5",
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.emailModal.submissionErrors.title"
        }),
        type: "danger"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.emailModal.submissionErrors.body"
      }))), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UILoadingButton.default, {
        use: "primary",
        onClick: this.handleSubmit,
        loading: pqlSubmissionStatus === PQL_SUBMISSION_STATUSES.LOADING,
        keepResultAfterFinish: pqlSubmissionStatus !== PQL_SUBMISSION_STATUSES.FAILED,
        failed: pqlSubmissionStatus === PQL_SUBMISSION_STATUSES.FAILED
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.emailModal.send"
      })), _react.default.createElement(_UIButton.default, {
        use: "secondary",
        onClick: this.handleClose
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.emailModal.cancel"
      }))));
    }
  }]);
  return EmailModal;
}(_react.default.Component);

var _default = EmailModal;
exports.default = _default;
module.exports = exports.default;